import loadable from '@loadable/component';

const LazyTagSuggestions = loadable(() => import('./TagSuggestions'), {
    resolveComponent: (components) => components.TagSuggestions,
});
const LazyFilterSuggestions = loadable(() => import('./FilterSuggestions'), {
    resolveComponent: (components) => components.FilterSuggestions,
});
const LazyEventSuggestions = loadable(() => import('./EventSuggestions'), {
    resolveComponent: (components) => components.EventSuggestions,
});

export { LazyTagSuggestions as TagSuggestions };
export { LazyFilterSuggestions as FilterSuggestions };
export { LazyEventSuggestions as EventSuggestions };
